module.exports = __webpack_public_path__ + "img/appleid_button.24b6e8fb.png";